import $ from 'jquery';
import slick from 'slick-carousel';

$(function(){
  $('.js-cm-Character__items').slick({
    autoplay: true,
    autoplaySpeed: 6000,
    dots: false,
    prevArrow:'<button class="slick-prev"></button>',
    nextArrow:'<button class="slick-next"></button>'
  });
});
